<template>
<!-- 显示设置 -->
    <div>
        <el-form ref="form" :model="form" :label-width="labelWidth">
            <el-form-item label="试题样式">
                <el-select v-model="form.question_type" placeholder="请选择试题样式">
                    <el-option label="默认" value="0"></el-option>
                </el-select>
            </el-form-item>
            <!--  -->
            <el-form-item label="">
                <img class="questions" src="@a/measurement/questions.png" alt="" />
            </el-form-item>
            <!--  -->
            <el-form-item label="报告样式">
                <el-select v-model="form.report_type" placeholder="请选择报告样式">
                    <el-option label="默认" value="0"></el-option>
                </el-select>
            </el-form-item>
            <!--  -->
            <el-form-item label="">
                <img class="report" src="@a/measurement/report.jpg" alt="" />
            </el-form-item>
            <!--  -->
            <el-form-item>
                <el-button type="primary" @click="accordingSubmit">保存</el-button>
                <el-button @click="$router.go(-1)">返回</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { theme } from "@/api/measurement";
export default {
    data() {
        return{
            labelWidth:'120px',
            form:{
                question_type: '0',
                report_type: '0'
            }
        }
    },
    methods:{
        pullData(){
            this.$showLoading();
            theme({
                eid:this.$route.query.id
            }).then((data)=>{
                if(data.list && (data.list.question_type !== undefined && data.list.report_type !== undefined)) {
                    this.form = data.list;
                }
                this.$hideLoading();
            }).catch(()=>{
                this.$hideLoading();
            });
        },
        accordingSubmit(){
            this.form['eid'] = this.$route.query.id;
            this.form['question_type'] = this.form.question_type;
            this.form['report_type'] = this.form.report_type;
            theme(this.form).then((data)=>{
                if(data.error >0){
                    this.$message(data.msg);
                    return
                }
               this.$notify({
                    title: '成功',
                    message: '保存成功',
                    type: 'success'
                });
                this.pullData();
            });
        }
    }, 
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.questions{
    width: 100px;
}
.report{
    width: 100px;
}
</style>
